import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Definiciones } from '@p-p-portafolio/promociones/interfaces/definiciones';
import { SwalService } from '@shared/utils/swal.service';
import { ControlsService } from '@shared/services/controls/controls.service';
import { DefinicionesService } from '@p-p-portafolio/promociones/services/definiciones.service';
import { ControlBase } from '@shared/components/generic-form/models/control-base';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EstatusLegalesResponse, IGetEstLegErr, IGetEstLegErrRes } from '@p-p-portafolio/promociones/interfaces/estatus-legales';
import { EstatusLegalesService } from '@p-p-portafolio/promociones/services/estatus-legales.service';
import { EstatusLegalesComponent } from '../estatus-legales.component';

@Component({
  selector: 'app-estatus-legales-form',
  templateUrl: './estatus-legales-form.component.html',
  styleUrls: ['./estatus-legales-form.component.css']
})
export class EstatusLegalesFormComponent implements OnInit {
  isEditing: boolean = false;

  controls$: Observable<ControlBase<any>[]>;
  diasDuesOptions = [];
  clasCarteraOptions = [];
  origenReservaOptions = [];

  form: UntypedFormGroup;

  screenId: number = 36;

  constructor(
    private _fb: UntypedFormBuilder,
    public estatusLegalesService: EstatusLegalesService,
    private controlService: ControlsService,
    private _dialogRef: MatDialogRef<EstatusLegalesComponent>,
    private swalService: SwalService,
    @Inject(MAT_DIALOG_DATA) public data: { promocion: string; elemento: EstatusLegalesResponse }
  ) {}

  ngOnInit(): void {
    this.readLstEstl();
    this.readLstEstlCC();
    this.readLstEstlOR();

    this.form = this._fb.group({
      query: [1],
      estatus: ['', Validators.required],
      promocion: ['', Validators.required],
      diasDues: [0, Validators.required],
      minimo: [0, Validators.required],
      maximo: [0, Validators.required],
      descripcion: ['', Validators.required],
      provision: [0, Validators.required],
      provisionInt: [0, Validators.required],
      clasCartera: [0, Validators.required],
      porcGarantia: [0, Validators.required],
      origenReserva: [0, Validators.required],
      iPorDefinir: [0, Validators.required]
    });

    if (this.data.elemento) {
      this.isEditing = true;
      console.log(this.data.elemento);

      this.form.patchValue({
        estatus: this.data.elemento.estatusLegal,
        promocion: this.data.promocion,
        diasDues: this.data.elemento.diasDues,
        minimo: this.data.elemento.minimo,
        maximo: this.data.elemento.maximo,
        descripcion: this.data.elemento.descripcion,
        provision: this.data.elemento.provision,
        provisionInt: this.data.elemento.provisionInt,
        clasCartera: this.data.elemento.clasCartera,
        porcGarantia: this.data.elemento.porcGarantia,
        origenReserva: this.data.elemento.origenReserva,
        iPorDefinir: 0
      });
    }
  }

  readLstEstl() {
    this.estatusLegalesService.GetLstEstl(this.data.promocion).subscribe((res) => {
      this.diasDuesOptions = res.data;
    });
  }

  readLstEstlCC() {
    this.estatusLegalesService.GetLstEstlCC(this.data.promocion).subscribe((res) => {
      this.clasCarteraOptions = res.data;
    });
  }

  readLstEstlOR() {
    this.estatusLegalesService.GetLstEstlOR(this.data.promocion).subscribe((res) => {
      this.origenReservaOptions = res.data;
    });
  }

  create() {
    const payload: IGetEstLegErr = {
      que: 1, // El 1 indica que se trata de un nuevo registro
      promocion: this.data.promocion,
      estatus: this.form.get('estatus')?.value,
      diasDues: this.form.get('diasDues')?.value,
      minimo: this.form.get('minimo')?.value,
      maximo: this.form.get('maximo')?.value,
      descripcion: this.form.get('descripcion')?.value,
      provision: this.form.get('provision')?.value,
      provisionInt: this.form.get('provisionInt')?.value,
      clasCartera: this.form.get('clasCartera')?.value,
      porcGarantia: this.form.get('porcGarantia')?.value,
      origenReserva: this.form.get('origenReserva')?.value,
      iPorDefinir: 0
    };
    this.estatusLegalesService.GetEstLegErr(payload).subscribe(
      (res: IGetEstLegErrRes) => {
        if (res.success) {
          this.swalService.success('El Estado Legal se ha añadido correctamente');
          this.close();
        } else {
          this.swalService.error('Ocurrió un error al crear el Estado Legal');
        }
      },
      (error) => {
        this.swalService.error(error);
      }
    );
  }

  update() {
    const payload: IGetEstLegErr = {
      que: 2, // El 2 indica que se trata de un registro existente
      promocion: this.data.promocion,
      estatus: this.form.get('estatus')?.value,
      diasDues: this.form.get('diasDues')?.value,
      minimo: this.form.get('minimo')?.value,
      maximo: this.form.get('maximo')?.value,
      descripcion: this.form.get('descripcion')?.value,
      provision: this.form.get('provision')?.value,
      provisionInt: this.form.get('provisionInt')?.value,
      clasCartera: this.form.get('clasCartera')?.value,
      porcGarantia: this.form.get('porcGarantia')?.value,
      origenReserva: this.form.get('origenReserva')?.value,
      iPorDefinir: 0
    };
    this.estatusLegalesService.GetEstLegErr(payload).subscribe(
      (res: IGetEstLegErrRes) => {
        if (res.success) {
          this.swalService.success('El Estado Legal se ha actualizado correctamente');
          this.close();
        } else {
          this.swalService.error('Ocurrió un error al actualizar el Estado Legal');
        }
      },
      (error) => {
        this.swalService.error(error);
      }
    );
  }

  close() {
    this._dialogRef.close();
  }
}
